import { UAParser } from './index';

/**
 * 判断微信小程序环境
 */
export const isInMiniProgram = () => {
  const { wxMiniProgram } = UAParser();
  return wxMiniProgram;
};
